module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "items"
  }, [_c('v-layout', _vm._b({}, 'v-layout', _vm.layout, false), [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md8": "",
      "lg9": ""
    }
  }, [_vm._l((_vm.projects), function(item, index) {
    return (item.order_item_ids.length < 1) ? [_c('card', {
      attrs: {
        "item": item,
        "index": index,
        "item-type": "unordered"
      }
    })] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return [_c('card', {
      attrs: {
        "item": item,
        "index": index,
        "item-type": "ordered"
      }
    })]
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('cart')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8bba034","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/index.vue
// module id = 774
// module chunks = 1